export class InteractionInfo {
	public welcomeMsg: string;
	public userSession: string;
	public participantId: string;
	public agentName: string;
}